import { ESecondaryItemType, SecondaryItem } from "@similarweb/ui-components";

import type { INavItem } from "app/components/sidebar3/types";
import { translate } from "app/filters/i18nFilter";

import { ROUTES } from "./keywords/constants";
import { TRADEMARK_ROUTES } from "./trademark/constants";

export type MnPNavBarRouteOverrides = {
    homeStateName?: string;
    overviewStateName?: string;
    competitorsStateName?: string;
    keywordsStateName?: string;
    adsStateName?: string;
    trademarkAbstractStateName?: string;
    trademarksStateName?: string;
    violationsStateName?: string;
};

export const buildMonitorAndProtectNavigationSettings = (overrides?: MnPNavBarRouteOverrides): INavItem[] => [
    {
        get title() {
            return translate("monitor_and_protect.app.navigation.home");
        },
        name: ROUTES.HOME.camelCase,
        state: overrides?.homeStateName ?? ROUTES.HOME.stateName,
        itemComponent: SecondaryItem,
        itemType: ESecondaryItemType.Standalone,
    },
    {
        get title() {
            return translate("monitor_and_protect.app.navigation.keyword_monitoring");
        },
        name: ROUTES.OVERVIEW.camelCase,
        state: overrides?.overviewStateName ?? ROUTES.OVERVIEW.stateName,
        subItems: [
            {
                get title() {
                    return translate("monitor_and_protect.app.navigation.overview");
                },
                name: ROUTES.OVERVIEW.camelCase,
                state: overrides?.overviewStateName ?? ROUTES.OVERVIEW.stateName,
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
            },
            {
                get title() {
                    return translate("monitor_and_protect.app.navigation.competitors");
                },
                name: ROUTES.COMPETITORS.camelCase,
                state: overrides?.competitorsStateName ?? ROUTES.COMPETITORS.stateName,
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
            },
            {
                get title() {
                    return translate("monitorandprotect.feature.keywords.title");
                },
                name: ROUTES.KEYWORDS.camelCase,
                state: overrides?.keywordsStateName ?? ROUTES.KEYWORDS.stateName,
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
            },
            {
                get title() {
                    return translate("monitor_and_protect.app.navigation.searchAds");
                },
                name: ROUTES.ADS.camelCase,
                state: overrides?.adsStateName ?? ROUTES.ADS.stateName,
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
            },
        ],
    },
    {
        get title() {
            return translate("monitor_and_protect.app.navigation.trademark_protection");
        },
        name: TRADEMARK_ROUTES.ABSTRACT.camelCase,
        state: overrides?.trademarkAbstractStateName ?? TRADEMARK_ROUTES.ABSTRACT.stateName,
        subItems: [
            {
                get title() {
                    return translate("monitor_and_protect.app.navigation.trademarks");
                },
                name: TRADEMARK_ROUTES.TRADEMARKS.camelCase,
                state: overrides?.trademarksStateName ?? TRADEMARK_ROUTES.TRADEMARKS.stateName,
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
            },
            {
                get title() {
                    return translate("monitor_and_protect.app.navigation.dashboard");
                },
                name: TRADEMARK_ROUTES.VIOLATIONS.camelCase,
                state: overrides?.violationsStateName ?? TRADEMARK_ROUTES.VIOLATIONS.stateName,
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
            },
        ],
    },
];

export const navigationSettings: INavItem[] = buildMonitorAndProtectNavigationSettings();
